import React, { useEffect, useState } from 'react';
import style from './App.module.scss';
import classnames from 'classnames';
import { useSearchParams } from 'react-router-dom';
import { defaultSport, yearlyOnly } from '../../constants';
import { IPlan } from '../../model';
import RenewNowModal from '../RenewNowModal/RenewNowModal';
import { AppContext } from '../../context/AppContext';
import { useAuth } from '../../context/Auth.context';
import Toolbar from '../Toolbar/Toolbar';
import MainContent from '../MainContent';
import { useGetPlans } from '../../hooks/useGetPlans.hook';

function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const querySport = searchParams.get('sport');
  const {subscriptions, loading, baseCheckoutPath} = useAuth();
  const [selectedSport, setSelectedSport] = useState<string>(querySport || defaultSport);
  const [isShowAll, showAll] = useState<boolean>(false);
  const [yearly, setYearly] = useState<boolean>(searchParams.get('period') !== 'monthly');
  const [renewPopup, showRenewPopup] = useState<null | { plan: IPlan }>(null);
  const [preparedPlans, setPreparedPlans] = useState<IPlan[]>([]);

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (!yearly) {
      newSearchParams.set('period', 'monthly')
    } else {
      newSearchParams.delete('period')
    }
    if (window.location.pathname.indexOf('/pricing') !== -1) {
      setSearchParams(newSearchParams)
    }
  }, [yearly])

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('sport', selectedSport)
    if (window.location.pathname.indexOf('/pricing') !== -1) {
      setSearchParams(newSearchParams);
    }
  }, [selectedSport])

  let {
    loading: plansLoading,
    withoutDisabledPlans,
    showTimePeriodSwitcher,
    yearly: yearlyProcessed,
    plans: filteredPlans,
    totalPrice,
    currentSubscriptions,
    onePaymentItems,
    precessedOnePaymentItems
  } = useGetPlans(subscriptions || [], selectedSport, isShowAll, yearly);

  const toggleAdditionalPlan = (id: string, state?: boolean) => {
    setPreparedPlans(preparedPlans.map(plan => plan.plan_id === id ? ({
      ...plan,
      isAdditional: state ?? !plan.isAdditional
    }) : plan))
  };

  useEffect(() => {
    setPreparedPlans(
      filteredPlans.filter(plan => {
        return !yearlyProcessed ? (!yearlyOnly.includes(plan.plan_id)) : true
      })
    );
  }, [filteredPlans]);

  return (
    <AppContext.Provider value={{
      yearly: yearlyProcessed,
      currentSubscriptions,
      totalPrice,
      sport: selectedSport,
      baseCheckoutPath,
      toggleAdditionalPlan,
      showRenewPopup,
      showAll,
      isShowAll
    }}>
      <div className={classnames(style.container)} style={{paddingBottom: 80, overflow: 'hidden'}}>
        {plansLoading || loading
          ?
          <div className={classnames(style.loader)} style={{margin: '30px auto'}}>
            <span/><span/><span/><span/><span/>
          </div>
          : <>
            <Toolbar plans={withoutDisabledPlans} onePaymentItems={precessedOnePaymentItems} yearly={yearlyProcessed}
                     setYearly={showTimePeriodSwitcher ? setYearly : undefined} selectedSport={selectedSport}
                     setSelectedSport={setSelectedSport}/>
            <div className={style.sport_info_block__wrapper}>
              {selectedSport === 'mlb' ? <div className={style.sport_info_block}>
                You may add <strong>Baseball</strong> either through a baseball only plan or select <strong>All
                Sports</strong>
              </div> : ''}
            </div>
            <MainContent plans={preparedPlans} onePaymentItems={onePaymentItems} sport={selectedSport}/>
          </>
        }
      </div>
      {renewPopup ? <RenewNowModal plan={renewPopup.plan} close={() => showRenewPopup(null)}/> : ''}
    </AppContext.Provider>
  );
}

export default App;
